import { useMutation } from '@tanstack/react-query'
import { OptionalMutationOptions } from 'src/queries/agent/domain/queries.utils'
import {
  PostAgentPromptRequest,
  PostAgentPromptResponse,
} from 'src/queries/agent/network/agent.models'
import { postAgentPrompt } from 'src/queries/agent/network/agent.network'
import { agentQueryKeys } from 'src/queries/queries.constants'

export const usePostAgentPrompt = (
  options?: OptionalMutationOptions<
    PostAgentPromptResponse,
    PostAgentPromptRequest
  >,
) => {
  return useMutation({
    mutationFn: (data) => postAgentPrompt(data),
    mutationKey: agentQueryKeys.prompt(),
    ...options,
  })
}
